export default __webpack_public_path__ + "static/media/image3.4f325a4b.jpg";